import React from "react";
import { getWeatherIcon } from "../../services/weatherApi";
import "./Forecast.css";

const Forecast = ({ data }) => {
  // Group forecast by day
  const dailyForecast = data.list.reduce((acc, item) => {
    const date = new Date(item.dt * 1000).toLocaleDateString("en-US", {
      weekday: "short",
    });

    if (!acc[date]) {
      acc[date] = {
        date,
        temps: [],
        icons: [],
        descriptions: [],
      };
    }

    acc[date].temps.push(item.main.temp);
    acc[date].icons.push(item.weather[0].icon);
    acc[date].descriptions.push(item.weather[0].description);

    return acc;
  }, {});

  const forecastDays = Object.values(dailyForecast)
    .slice(0, 5)
    .map((day) => ({
      day: day.date,
      high: Math.round(Math.max(...day.temps)),
      low: Math.round(Math.min(...day.temps)),
      icon: day.icons[Math.floor(day.icons.length / 2)],
      description: day.descriptions[Math.floor(day.descriptions.length / 2)],
    }));

  return (
    <div className="forecast glass-card">
      <h3>📅 5-Day Forecast</h3>
      <div className="forecast-list">
        {forecastDays.map((day, index) => (
          <div
            key={index}
            className={`forecast-item ${index === 0 ? "today" : ""}`}
          >
            <span className="forecast-day">
              {index === 0 ? "Today" : day.day}
            </span>
            <img
              src={getWeatherIcon(day.icon)}
              alt={day.description}
              className="forecast-icon"
            />
            <span className="forecast-desc">{day.description}</span>
            <div className="forecast-temps">
              <span className="forecast-high">{day.high}°</span>
              <span className="forecast-low">{day.low}°</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Forecast;
